import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Button } from 'components/common';
import { DropdownSelectable } from 'components/common/dropdown';

export type PathViewOptions = 'administered' | 'available' | 'search' | 'user';

interface Props {
  isAdmin: boolean;
  view: PathViewOptions;
  setView: React.Dispatch<React.SetStateAction<PathViewOptions>>;
  showSearch: boolean;
}

const PathsContentHeader = ({ isAdmin, view, setView, showSearch }: Props) => {
  const { messages } = useReduxState();

  return (
    <div>
      <div className="dropdown-view-selector">
        <DropdownSelectable
          align="left"
          category="transparent"
          defaultText={`${messages.commonSelect}...`}
          defaultValue={isAdmin ? 'administered' : 'user'}
          dropdownTextMinWidth="120px"
          onChange={(view: PathViewOptions) => setView(view)}
          options={[
            ...(isAdmin
              ? [
                  {
                    text: messages.coursesAdministered,
                    value: 'administered'
                  }
                ]
              : []),
            {
              text: messages.pathsMyPaths,
              value: 'user'
            },
            {
              text: messages.pathsAvailablePaths,
              value: 'available'
            },
            ...(showSearch
              ? [
                  {
                    text: messages.commonSearch,
                    value: 'search'
                  }
                ]
              : [])
          ]}
          showSelectedText={true}
          size="medium"
          titleMaxWidth={120}
          value={view}
        />
      </div>

      <div className="view-selection">
        {isAdmin ? (
          <Button
            category={view === 'administered' ? 'white' : 'transparent'}
            onClick={() => setView('administered')}
            text={messages.coursesAdministered}
          />
        ) : null}
        <Button
          category={view === 'user' ? 'white' : 'transparent'}
          onClick={() => setView('user')}
          text={messages.pathsMyPaths}
        />
        <Button
          category={view === 'available' ? 'white' : 'transparent'}
          onClick={() => setView('available')}
          text={messages.pathsAvailablePaths}
        />
        {showSearch ? (
          <Button
            category={view === 'search' ? 'white' : 'transparent'}
            onClick={() => setView('search')}
            text={messages.commonSearch}
          />
        ) : null}
      </div>

      <style jsx>{`
        .dropdown-view-selector {
          display: none;
        }
        .view-selection {
          display: flex;
          gap: 20px;
          margin-bottom: 30px;
        }
        @media (max-width: ${breakpoints.medium - 1}px) {
          .dropdown-view-selector {
            display: block;
            margin-bottom: 30px;
          }
          .view-selection {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default PathsContentHeader;
